import React from "react";

import './title.scss';

const IntroParagraphContents = ({sectionContent,tocContent}) => {
return (
<div className="container">
<h1 className={tocContent !== '' ? "headline-title pt-md-5 col-sm-12 col-md-12 col-lg-7" : "headline-title pt-md-5 col-sm-12 col-md-12 col-lg-10 offset-lg-1"}>
    {sectionContent}
</h1>
</div>
)
}

export default IntroParagraphContents; 